import { useLanguage } from 'hooks';
import Feature from './Feature';
import './Section3.scss';

const Section3 = () => {
	const { section3 } = useLanguage();

	return (
		<section className="section3">
			<div className="section3__heading">
				<h2>{section3.heading}</h2>
			</div>
			<div className="section3__features">
				<Feature features={section3.features} />
			</div>
		</section>
	);
};

export default Section3;